import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';

type Props = {
  profile: NewProfile;
};

const ProfileBanner: React.FC<Props> = ({ profile }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div className="card border-0 w-100">
      {!isLoaded && (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            margin: 10,
            borderRadius: 10,
            maxHeight: 250,
            backgroundColor: '#f0f0f0',
            height: 250,
          }}
        >
          <Spinner
            animation="border"
            role="status"
            className="text-warning align-self-center"
          />
        </div>
      )}
      <img
        src={`${profile.cover ?? 'assets/images/banner-1200x250.png'}`}
        alt="avatar"
        style={{
          margin: 10,
          borderRadius: 10,
          maxHeight: 250,
          display: isLoaded ? 'block' : 'none',
        }}
        onLoad={() => setIsLoaded(true)}
      />
    </div>
  );
};

export default ProfileBanner;
